module.exports = __webpack_public_path__ + "img/status-rank.fd28c646.png";